// Курс обмена: 1 кристалл -> 50 нуменов. Общий для клиента и сервера —
// см. server/index.js (эндпоинт /api/exchange-crystals). Обмен односторонний,
// нумены обратно в кристаллы не конвертируются
export const CRYSTALS_TO_NUMENS_RATE = 50;

// Улучшенный курс для пользователей с действующим премиумом (активность
// проверяет сервер по premiumExpiresAt на момент обмена)
export const CRYSTALS_TO_NUMENS_RATE_PREMIUM = 100;
